import React from "react";
import classnames from "classnames";
import "./RadioButton.css";
import PropTypes from "prop-types";

const RadioButton = ({
  label,
  onChange,
  checked,
  className,
  disabled,
  style,
  containerClassName,
  value,
  name,
}) => (
  <div
    className={classnames(
      "col-sm-12 text-left input-label",
      containerClassName
    )}
  >
    <label className="radio-label" style={style}>
      <input
        className={classnames("radio", className)}
        type="radio"
        checked={checked}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
        style={style}
        value={value}
        name={name}
      />
      {label}
    </label>
  </div>
);

RadioButton.propTypes = {
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  containerClassName: PropTypes.object,
  value: PropTypes.any,
  name: PropTypes.string,
};

RadioButton.defaultProps = {
  className: undefined,
  label: undefined,
  checked: false,
  onChange: undefined,
  containerClassName: undefined,
};
export default RadioButton;
